const emptyObject = Object.freeze({})

const emptyList: any[] = []

const noOp = () => emptyObject

export { emptyObject, emptyList, noOp }
